import React, { Component } from "react";
import {
	Box,
	Button,
	Typography,
	Grid,
	GridList,
	GridListTile,
	IconButton,
	Dialog, 
	DialogTitle, 
	DialogActions, 
	DialogContent
} from "@material-ui/core";
import ReactCrop from "react-image-crop";
import FileUploadIcon from "@material-ui/icons/CameraAltRounded";
import DeleteIcon from "@material-ui/icons/Delete";
import InfoIcon from "@material-ui/icons/Info";
import { Field } from "redux-form";
import FileInput from "./FileInput";
import ContentSelectAll from "@material-ui/icons/SelectAll";

const styles = {
	gridList: {
		display: "flex",
		flexWrap: "nowrap",
		overflowX: "auto",
		width: "auto"
	},
	input: {
		cursor: "pointer",
		position: "absolute",
		top: 0,
		bottom: 0,
		right: 0,
		left: 0,
		width: "100%",
		opacity: 0
	}
};

class ImageSelector extends Component {
	constructor(props) {
		super(props);
		this.onSelect = this.onSelect.bind(this)
		// console.log("IMAGE ", props.imagePreviewUrl)
		this.state = {
			imagePreviewUrl: this.props.imagePreviewUrl,
			sizeErrorText: null,
			fileName: this.props.fileName,
			crop: this.props.crop,
			// crop: {
			// 	unit: "%",
			// 	width: 30,
			// 	aspect: 1
			// },
			open:false,
			croppedImageUrl: this.props.imagePreviewUrl,
			croppedFileName: this.props.fileName,
			imgBlob:null,
			src:null
		};
	}
	componentWillReceiveProps(nextProps) {
		// console.log("NUEVAS PROPS IMAGE ",nextProps.imagePreviewUrl, this.props.imagePreviewUrl, nextProps.fileName, this.props.fileName)

		if (nextProps.imagePreviewUrl !== this.props.imagePreviewUrl) {
			// console.log("CHANGE IMAGE ", nextProps.imagePreviewUrl, this.props.imagePreviewUrl, nextProps.fileName, this.props.fileName)
			this.setState({
				imagePreviewUrl: nextProps.imagePreviewUrl,
				fileName: nextProps.fileName,
				croppedImageUrl: nextProps.imagePreviewUrl,
				croppedFileName: nextProps.fileName,
			});
		}
	}
	onImageLoaded = (image, pixelCrop) => {
    // console.log("onImageLoaded");
    this.imageRef = image;
  };

  onCropComplete = (crop, pixelCrop) => {
    // console.log("onCropComplete");
    this.makeClientCrop(crop, pixelCrop);
  };

  onCropChange = crop => {
    // console.log("onCropChange");
    this.setState({ crop });
  };

  async makeClientCrop(crop, percentCrop) {
    // console.log("makeClientCrop 1", crop, percentCrop);
    if (this.imageRef && crop.width && crop.height) {
      // console.log("makeClientCrop 2");
      const imgBlob = await this.getCroppedImg(
        this.imageRef,
        crop,
        this.state.fileName
      );
      window.URL.revokeObjectURL(this.fileUrl);
			this.fileUrl = window.URL.createObjectURL(imgBlob);
      this.setState({ croppedImageUrl: this.fileUrl, imgBlob });
    }
  }

  getCroppedImg(image, crop, fileName) {
    // console.log("CROP IMG",image, crop, fileName);
    const canvas = document.createElement("canvas");
    const scaleX = image.naturalWidth / image.width;
    const scaleY = image.naturalHeight / image.height;
    canvas.width = crop.width;
		canvas.height = crop.height;
		// canvas.style = "background-color:transparent"
		const ctx = canvas.getContext("2d");
		// console.log("CROP", crop, scaleX, scaleY, image.naturalWidth, image.naturalH)
    ctx.drawImage(
      image,
      crop.x * scaleX,
      crop.y * scaleY,
      crop.width * scaleX,
      crop.height * scaleY,
      0,
      0,
      crop.width,
      crop.height
    );

    return new Promise((resolve, reject) => {
      canvas.toBlob(blob => {
        if (!blob) {
          //reject(new Error('Canvas is empty'));
          console.error("Canvas is empty");
          return;
        }
        blob.name = fileName;
        resolve(blob);
      }, this.state.fileType);
    });
	}
	
	handleImageChange(e) {
		e.preventDefault();
		let reader = new FileReader();
		reader.onloadend = () =>
			this.setState({ src: reader.result, sizeErrorText: null });
		reader.readAsDataURL(e.target.files[0]);

		if (e.type !== "blur")
			this.refs.field.getRenderedComponent().refs.FileInput.blur();
	}

	adaptFileEventToValue = delegate => e => {
		if (e.target.files[0]) {
			// console.log("FILE", e.target.files[0]?e.target.files[0].name:"FALSE")
			// e.preventDefault();
			// let reader = new FileReader()
			// let img = new Image()
			// let dimensions = {}

			// reader.onloadend = () => {
			// 	img.onload = () => {
			// 		dimensions.width = img.width
			// 		dimensions.height = img.height
			// 		console.log(img.width, img.height)
			// 		console.log(this.props.fileDimentions.width)
			// 		console.log(this.props.fileDimentions.height)
			// 	}
			// 	img.src = reader.result
			// }
			// reader.readAsDataURL(e.target.files[0])

			// if (e.target.files[0].size <= this.props.fileSize) {
				// if (e.target.files[0].size <= this.props.fileSize &&
				//img.width === this.props.fileDimentions.width &&
				//img.height === this.props.fileDimentions.height) {
				this.handleImageChange(e);
				//añadido para sindicato controlador de estado de la pantalla a la que pertenece
				// eslint-disable-next-line
				this.props.onChangeState ? this.props.onChangeState() : null;
				delegate(e.target.files[0]);
				this.setState({ fileName: e.target.files[0].name, open:true, fileType:e.target.files[0].type });
			// } else
			// 	this.setState({
			// 		sizeErrorText: `La imagen debe ser de 
			// ${this.props.fileDimentions.width}x
			// ${this.props.fileDimentions.height} y el tamaño no debe superar ${this.props
			// 				.fileSize / 1000}kb`,
			// 		fileName: null
			// 	});
		}
	};

	deleteFile = () => {
		const fieldName = this.props.fieldName;
		const dispatch = this.refs.field.context._reduxForm.dispatch;
		const change = this.refs.field.context._reduxForm.change;
		dispatch(change(fieldName, ""));
		this.refs.field.getRenderedComponent().refs.FileInput.value = "";
		this.setState({ imagePreviewUrl: null, fileName:null, croppedFileName:null });
		// eslint-disable-next-line
		this.props.onChangeDeleteFlag ? this.props.onChangeDeleteFlag() : null;
	};

	renderPreviews(previewUrl) {
		// let previewUrl = this.state.imagePreviewUrl;
		if (previewUrl)
			return (
				<Box style={this.props.styleRenderPreviews}>
					<Typography variant="subtitle1">Vista previa</Typography>
					<GridList cols={2} style={styles.gridList} cellHeight="auto">
						<GridListTile
							title=" "
							style={{ width: 300, height: 180 }}
							actionIcon={
								this.props.disabledUploadPhoto ? null : (
									<IconButton onClick={this.deleteFile}>
										<DeleteIcon color="white" />
									</IconButton>
								)
							}
						>
							<img
								style={{ height: "100%", width: "100%", objectFit: "contain" }}
								src={previewUrl}
								alt=""
							/>
						</GridListTile>
					</GridList>
				</Box>
			);
	}

	onSelect(){
		this.setState({imagePreviewUrl:this.state.croppedImageUrl, open:false, croppedFileName:this.state.fileName})
		this.props.onSelect(this.state.croppedImageUrl, this.state.imgBlob, this.state.fileName)
	}

	render() {
		// console.log("RENDER IMAGE STATE",this.state.imagePreviewUrl)
		const props = this.props;
		let previewStyle = this.state.imagePreviewUrl?{backgroundImage:`url("${this.state.imagePreviewUrl}")`}:{}
		let iconPreviewStyle =this.state.imagePreviewUrl?{opacity:0.5}:{}
		return (
			<Box className={props.classNameIS}>
				<Button
					variant="container"
					// labelPosition="before"
					// containerElement="label"
					style={{...props.styleButton, ...previewStyle}}
					disabled={
						this.props.disabledUploadPhoto
							? this.props.disabledUploadPhoto
							: false
					}
				>
					<FileUploadIcon color="primary" style={{fontSize:63, ...iconPreviewStyle}}/>
					{/*TODO Propagar el meta.field.error desde FileInput para informar las validaciones acá. */}
					<Field
						ref="field"
						name={props.fieldName}
						component={FileInput}
						validate={props.validate}
						style={styles.input}
						adaptEvent={this.adaptFileEventToValue}
						accept="image/x-png,image/jpeg"
						withRef
						disabled={
							this.props.disabledUploadPhoto
								? this.props.disabledUploadPhoto
								: false
						}
						validate={props.validate}
					/>
				</Button>
				{this.state.sizeErrorText ? (
					<Box className="display-flex align-center">
						<InfoIcon style={{ width: 16 }} />
						<p
							className="margin0 light"
							style={{ fontSize: 11, marginLeft: 5 }}
						>
							{this.state.sizeErrorText}
						</p>
					</Box>
				) : null}
				{this.props.noPreview ? (
					<Box className="display-flex align-center">
						<p
							className="margin0 light"
							style={{
								fontSize: 11,
								marginLeft: 5,
								whiteSpace: "nowrap",
								overflow: "hidden",
								textOverflow: "ellipsis"
							}}
						>
							{this.state.croppedFileName}
						</p>
						{this.props.showDelete&&this.state.imagePreviewUrl?
						<IconButton onClick={this.deleteFile}>
							<DeleteIcon color="primary" />
						</IconButton>
						:null}
					</Box>
				) : (
						this.renderPreviews(this.state.imagePreviewUrl)
					)}
			
				<Dialog	open={this.state.open} PaperProps={{style:{maxWidth:this.props.maxWidth*2+80}}}>
					<DialogTitle style={{color: "#0091d4", paddingBottom:8}}>Ajusta la imagen</DialogTitle>
					<DialogContent >
						<Box textAlign="end">Vista Previa</Box>
						<Grid container direction="row" cols={2} spacing={4}>
							<Grid item>
								<ReactCrop
									imageStyle={{ height: "100%", width:this.props.maxWidth, objectFit: "contain" }}
									src={this.state.src}
									crop={this.state.crop}
									onImageLoaded={this.onImageLoaded}
									onComplete={this.onCropComplete}
									onChange={this.onCropChange}
									// minHeight={175}
									// minWidth={375}
									maxHeight={this.props.maxHeight}
									maxWidth={this.props.maxWidth}
								/>
							</Grid>
							<Grid item>
								{/* {this.renderPreviews(this.state.croppedImageUrl)} */}
								<img style={{ maxWidth:"100%" }} src={this.state.croppedImageUrl} />
							</Grid>
						</Grid>
						{/* <Box
							style={{
								display: "flex",
								alignItems: "flex-start",
								justifyContent: "center"
							}}
						>
						{src && (
							<Box xs={6} sm={6} md={6}>
								<div className="bottom10" style={styles.label}>
									Ajuste el cuadro en la parte que desea mostrar
							</div>
								<ReactCrop
									src={src}
									crop={crop}
									onImageLoaded={this.onImageLoaded}
									onComplete={this.onCropComplete}
									onChange={this.onCropChange}
								/>
							</Box>
						)} */}
						{/* {croppedImageUrl ? (
							<Box>
								<div className="bottom10" style={styles.label}>
									Previsualización
							</div>
								<img
									src={croppedImageUrl}
									style={
										rectangle ? styles.imgProfileRectangle : styles.imgProfile
									}
									alt=""
								/>
							</Box>
						) : 
							null}
					</Box> */}
					
				</DialogContent>
				<DialogActions>
					{this.props.hideInfo?null:
					<Typography style={{marginLeft:12, position:"absolute", left:16, bottom:18, color:"rgb(180,180,180)"}}>
						Sugerimos seleccionar imágenes de {this.props.maxWidth}x{this.props.maxHeight}
					</Typography>
					}
					<Button onClick={()=>{this.setState({open:false})}}>Cancelar</Button>
					<Button onClick={this.onSelect}>Seleccionar</Button>
				</DialogActions>
			</Dialog >
		</Box>
		);
	}
}

export default ImageSelector;



// WEBPACK FOOTER //
// ./src/components/ImageSelector/ImageSelector.js